<template>
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="
          selectedUrl ? `master/list-packages/${inputs.id}` : `master/list-packages`
        "
      >
      
				
        <div class="form-group row align-items-center">
          <label for="inputs_academic_calendar_id" class="col-sm-3 mb-0">
            Semester
          </label>
          <app-input
            id="inputs_academic_calendar_id"
            class="col-sm-9"
            type="advance-search-select"
            :loaded-per-time="10"
            v-model="input_academic_calendar_id"
            @input="setAcademicCalendar"
            fetch-url="master/academic-calendar"
            placeholder="Semester"
            list-value-field="academic_calendar_name"
            :required="true"
          />
        </div>
        
				<div class="form-group row align-items-center">
					<label for="inputs_product_id" class="col-sm-3 mb-0">
						Product
					</label>
					<app-input
						id="inputs_product_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_product_id"
						@input="setProductId"
						fetch-url="/master/product?product_category_exclude=3,2"
						placeholder="Product"
						list-value-field="name"
            :disabled="!!inputs.id" 
					/>
				</div>
        <div class="form-group row align-items-center">
          <label class="col-sm-3 mb-0" style="font-size: 12px;">Package Name</label>

          <div class="col-sm-2">
              <app-input type="text" v-model="teachingCode" read-only disabled />
          </div>

          <div class="col-sm-2">
              <app-input type="text" v-model="productCategoryCode" read-only disabled />
          </div>

          <div class="col-sm-2">
              <app-input type="text" v-model="inputs.sequence" placeholder="001" @input="checkUniqueSequence()" :disabled="!!inputs.id" />
          </div>

          <div class="col-sm-3">
              <app-input type="text" v-model="finalCode" read-only disabled />
          </div>
        </div>
				<div class="form-group row align-items-center">
					<label for="inputs_student_care_id" class="col-sm-3 mb-0">
						Student Care
					</label>
					<app-input
						id="inputs_student_care_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_student_care_id"
						@input="setStudentCareId"
						fetch-url="user-list?role_name=Student Care"
						placeholder="Student Care"
						list-value-field="full_name"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_academic_advisor_id" class="col-sm-3 mb-0">
						Academic Advisor
					</label>
					
					<app-input
						id="inputs_academic_advisor_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_academic_advisor_id"
						@input="setAcademicAdvisorId"
						fetch-url="user-list?role_name=Academic Advisor"
						placeholder="Academic Advisor"
						list-value-field="full_name"
					/>
				</div>
				<div class="form-group row align-items-center">
          <div class="col-md-12"></div>
				</div>

        <button type="button"
                class="btn btn-danger btn-with-shadow"
                @click="btnAddListClass" :disabled="!inputs.academic_calendar_id">
          <i class="fa fa-plus"></i>
        </button> 
        <div v-for="(pkg, index) in classList" :key="index" class="form-group row align-items-center mt-2">
            <label class="col-sm-2 mb-0" style="font-size: 12px;">Class {{ index + 1 }}</label>

                    
                <app-input
                    id="inputs_product_status_id"
                    class="col-sm-9"
                    type="advance-search-select"
                    :loaded-per-time="10"
                    v-model="pkg.course_id"
                    @input="setCourseId"
                    :fetch-url="`transaction/new-course?semester=${inputs.academic_calendar_id}`"
                    placeholder="Class Name"
                    list-value-field="course_name"
                    :required="true"
                />

            <div class="col-sm-1">
              <button type="button" class="btn btn-danger btn-sm" @click="removeClass(index)">
                <i class="fa fa-trash"></i>
              </button>
            </div>
        </div>
        <div class="form-group row align-items-center"><br></div>
        <div class="form-group row align-items-center"><br></div>
        <div class="form-group row align-items-center"><br></div>
        <div class="form-group row align-items-center"><br></div>
        <div class="form-group row align-items-center"><br></div>
        <div class="form-group row align-items-center"><br></div>
        <div class="form-group row align-items-center"><br></div>
        <div class="form-group row align-items-center"><br></div>
      </form>
    </template>
  </modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";
export default {
  name: "ModalForm",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
    formId: String,
    value: {
      type: Object,
      default: () => {
        return {
          id: "",
        };
      },
    },
  },
  data() {
    return {
      preloader: false,
      inputs: {
        id: null,
        sequence:null,
        academic_calendar_id:null
      },
      teachingCode: '',
      productCategoryCode: '',
      finalCode: '',
      packagesName:'',
      input_academic_calendar_id : {
        id: null,
        academic_calendar_name: null
      },
      input_product_id:{},
     	input_student_care_id: {},
     	input_academic_advisor_id: {},
      classList: [], 

      modalId: this.formId,
      modalTitle: this.$t("add"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      this.preloader = true;
    }
  },
  mounted() {
    this.observeLoadMoreButton();
    const observer = new MutationObserver(() => {
      this.observeLoadMoreButton();
    });

    observer.observe(document.body, { childList: true, subtree: true });
  },
  methods: {
    submit() {
      this.inputs.class_list = this.classList;
      this.save(this.inputs);
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      
			let studentCare = {};

			if (response.data.student_care?.id) {
				studentCare = {
					id: response.data.student_care?.id,
					full_name: response.data.student_care?.full_name
				};
			}

			this.setStudentCareId(studentCare,true);

			let academicAdvisor = {};

			if (response.data.academic_advisor?.id) {
				academicAdvisor = {
					id: response.data.academic_advisor?.id,
					full_name: response.data.academic_advisor?.full_name
				};
			}

      this.input_academic_calendar_id = {
        id: response.data.academic_calendar?.id,
        academic_calendar_name: response.data.academic_calendar?.academic_calendar_name
      };
      this.inputs.academic_calendar_id = response.data.academic_calendar_id;
      this.setProductId(response.data.product);

			this.setAcademicAdvisorId(academicAdvisor,true);

      this.packagesName = response.data.package_name;
      this.classList = response.data.course_list_packages.map(pkg => ({
          course_id: {
              id: pkg.course_id,
              course_name: pkg.course.course_name
          }
      }));
  
			if (response.data.teaching_type?.teaching_type_id) {
          this.teachingCode = response.data.teaching_type.teaching_type_code;
			}

			if (response.data.product_category?.id) {
          this.productCategoryCode = response.data.product_category.category_code;
			}
      this.inputs.sequence = response.data.number_list;
      this.updateFinalCode();
      this.inputs.id = response.data.id;
    
      this.preloader = false;

    },
    btnAddListClass() {

        this.classList.push({
          course_id: ''
        });

    },
    removeClass(index) {
      this.classList.splice(index, 1); 
    },
    setCourseId(data) {
        this.inputs.course_id = data.id;
        if (data && data.hasOwnProperty("id")) {
            this.inputs.course_id = data.id;
        }
    },
    
		setStudentCareId(data, fromApi = false) {
			
			if (data && data.hasOwnProperty("id")) {
				if (!fromApi && this.inputs.student_care_id === data.id) {
					// kalau user pilih sama → reset
					this.$set(this.inputs, "student_care_id", null);
					this.$set(this, "input_student_care_id", {});
				} else {
					// kalau beda → set value baru (atau pertama kali dari API)
					this.$set(this.inputs, "student_care_id", data.id);
					this.$set(this, "input_student_care_id", data);
				}
			} else {
				// kalau kosong/null → reset
				this.$set(this.inputs, "student_care_id", null);
				this.$set(this, "input_student_care_id", {});
			}
		},
		setAcademicAdvisorId(data, fromApi = false) {
			
			if (data && data.hasOwnProperty("id")) {
				if (!fromApi && this.inputs.academic_advisor_id === data.id) {
					// kalau user pilih sama → reset
					this.$set(this.inputs, "academic_advisor_id", null);
					this.$set(this, "input_academic_advisor_id", {});
				} else {
					// kalau beda → set value baru (atau pertama kali dari API)
					this.$set(this.inputs, "academic_advisor_id", data.id);
					this.$set(this, "input_academic_advisor_id", data);
				}
			} else {
				// kalau kosong/null → reset
				this.$set(this.inputs, "academic_advisor_id", null);
				this.$set(this, "input_academic_advisor_id", {});
			}
		},
    
    setAcademicCalendar(data) {
      if (data && data.hasOwnProperty("id")) {
        this.$set(this.inputs, "academic_calendar_id", data.id);
      }

      this.$set(this, "input_academic_calendar_id", data);
    },
    setProductId(data) {
      if (data && data.hasOwnProperty("id")) {
        this.$set(this.inputs, "product_id", data.id);
            
        this.teachingCode = data.teaching_type?.teaching_type_code || '';
        this.productCategoryCode = data.product_category?.category_code || '';

        this.updateFinalCode();
      }

      this.$set(this, "input_product_id", data);
    },
    
    updateFinalCode() {
        this.finalCode = `${this.teachingCode}${this.productCategoryCode}${this.inputs.sequence}`;
    },
    checkUniqueSequence() {
        this.updateFinalCode(); 
    },
    
    observeLoadMoreButton() {
      setTimeout(() => {
        const dropdowns = document.querySelectorAll(
          ".dropdown-search-result-wrapper"
        );

        dropdowns.forEach((dropdown) => {
          // Hapus event lama untuk mencegah duplikasi
          dropdown.removeEventListener("scroll", this.handleScroll);
          dropdown.addEventListener("scroll", this.handleScroll);
        });
      }, 500);
    },

    handleScroll(event) {
      const dropdown = event.target;

      // Cari tombol di seluruh dokumen jika tidak ditemukan di dropdown
      let loadMoreBtn = dropdown.querySelector(
        ".btn.btn-light.btn-sm.btn-block"
      );
      if (!loadMoreBtn) {
        loadMoreBtn = document.querySelector(".btn.btn-light.btn-sm.btn-block");
      }

      if (!loadMoreBtn || this.isLoading) return;

      const scrollBottom =
        dropdown.scrollTop + dropdown.clientHeight >=
        dropdown.scrollHeight - 10;

      if (scrollBottom) {
        this.isLoading = true;
        loadMoreBtn.click();

        // Pastikan tombol telah diklik dengan benar
        setTimeout(() => {
          this.isLoading = false;
        }, 500); // Sesuaikan delay dengan waktu respons API
      }
    },
  }

};
</script>
